import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-trip-plan",
  "use": "icon-trip-plan-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-trip-plan\"><path d=\"m11.236 4.832 3.536 3.536-3.536 3.535V9.867h-2.5a2.501 2.501 0 0 0-2.495 2.336l-.005.165v3h-3v-3a5.5 5.5 0 0 1 5.279-5.496l.221-.004h2.5V4.831zM4.736.6 8.27 4.136l-2.035-.001v2.44a5.503 5.503 0 0 0-3.001 2.131V4.135H1.2L4.736.6z\" fill=\"currentColor\" fill-rule=\"nonzero\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol